"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLPPairsForTokenAddresses = exports.getCachedLPPairsForTokenAddresses = exports.queryAllLPPairsForTokenAddresses = exports.queryAllLPPairsForTokenAddressesPerFork = void 0;
const export_models_1 = require("../../models/export-models");
const uni_v2_like_subgraph_1 = require("../../graph/uni-v2-like-subgraph");
const cookbook_debug_1 = require("../../utils/cookbook-debug");
const uni_v2_like_subgraph_cache_1 = require("../../graph/graph-cache/uni-v2-like-subgraph-cache");
const queryAllLPPairsForTokenAddressesPerFork = async (uniswapV2Fork, networkName, tokenAddresses) => {
    try {
        return await uni_v2_like_subgraph_1.UniV2LikeSubgraph.queryPairsForTokenAddresses(uniswapV2Fork, networkName, tokenAddresses);
    }
    catch (cause) {
        if (!(cause instanceof Error)) {
            throw new Error('Unexpected non-error thrown', { cause });
        }
        cookbook_debug_1.CookbookDebug.error(cause);
        throw new Error('Failed to query LP pairs for token addresses.', { cause });
    }
};
exports.queryAllLPPairsForTokenAddressesPerFork = queryAllLPPairsForTokenAddressesPerFork;
const queryAllLPPairsForTokenAddresses = async (networkName, tokenAddresses) => {
    const allLPPairs = await Promise.all(Object.values(export_models_1.UniswapV2Fork).map(fork => {
        return (0, exports.queryAllLPPairsForTokenAddressesPerFork)(fork, networkName, tokenAddresses);
    }));
    return allLPPairs.flat();
};
exports.queryAllLPPairsForTokenAddresses = queryAllLPPairsForTokenAddresses;
const getCachedLPPairsForTokenAddresses = async (provider, networkName, tokenAddresses) => {
    try {
        return await uni_v2_like_subgraph_cache_1.UniV2LikeSubgraphCache.getCachedPairsForTokenAddresses(provider, networkName, tokenAddresses);
    }
    catch (cause) {
        if (!(cause instanceof Error)) {
            throw new Error('Unexpected non-error thrown', { cause });
        }
        cookbook_debug_1.CookbookDebug.error(cause);
        throw new Error('Failed to get cached LP pairs for token addresses.', {
            cause,
        });
    }
};
exports.getCachedLPPairsForTokenAddresses = getCachedLPPairsForTokenAddresses;
const getLPPairsForTokenAddresses = async (provider, networkName, tokenAddresses) => {
    try {
        return await (0, exports.getCachedLPPairsForTokenAddresses)(provider, networkName, tokenAddresses);
    }
    catch (cause) {
        if (!(cause instanceof Error)) {
            throw new Error('Unexpected non-error thrown', { cause });
        }
        cookbook_debug_1.CookbookDebug.error(cause);
        return (0, exports.queryAllLPPairsForTokenAddresses)(networkName, tokenAddresses);
    }
};
exports.getLPPairsForTokenAddresses = getLPPairsForTokenAddresses;
